"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadSource = void 0;
const core_1 = require("@angular/core");
let LeadSource = class LeadSource {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], LeadSource.prototype, "lead", void 0);
LeadSource = __decorate([
    (0, core_1.Component)({
        selector: 'lead-source',
        template: `
    {lead.source, select,
      MOBILE_DE {Mobile.de}
      AUTOSCOUT24 {AutoScout24}
      AWI {Händler Webseite}
      OTHER {Andere}
    }
  `,
    })
], LeadSource);
exports.LeadSource = LeadSource;
